{% verbatim %}

<li class="tag">
  <h5 class="tag-name"><a href="/photos?tag={{name}}">{{name}}</a></h5>
  <a href="{{user_url}}" rel="author" class="tag-author">{{username}}</a>
  <button class="remove-tag icon-close"></button>
</li>

{% endverbatim %}